module.exports = __webpack_public_path__ + "static/media/tiger-1200.735afea6.jpg";